import { useTranslation } from "next-i18next";

import { IconStateVerifiedOutlined } from "@/assets/icons/figma/IconStateVerifiedOutlined";
import { ProductUnknown } from "@/common/contracts/product.contracts";
import { cn } from "@/common/utils/css.utils";
import { isProductCurated } from "@/common/utils/product.utils";

type CuratedLabelProps = {
  product?: ProductUnknown;
  className?: string;
};

export const CuratedLabel = ({ product, className }: CuratedLabelProps) => {
  const { t } = useTranslation();

  if (!isProductCurated(product)) {
    return null;
  }

  return (
    <span
      className={cn(
        /* space-x rather than gap — flexbox gap is unsupported in older browsers. It only spaces
           element children, hence the span around the text. */
        "inline-flex items-center space-x-1 rounded-full bg-flavour-100 px-2 py-0.5 font-title text-sm leading-6 text-brand-600",
        className
      )}
    >
      <IconStateVerifiedOutlined className="size-4 shrink-0" />
      <span>{t("common:common-curated")}</span>
    </span>
  );
};
